import React from 'react';
import { useParams, Link } from 'react-router-dom';
import VideoComponent from './VideoComponent';
import '../App.css';

const VideoDetails = () => {
    // retrieve parameters (URL) from the route
    const { url } = useParams();

    // retrieve stored video name from local storage
    const name = localStorage.getItem('videoName');

    // display video name in header if it exists
    // render videocomponent with base URL and rendered URL
    return (
        <div className="video-details">
            <Link to="/training-videos" className="back-to-dashboard-button">
                Back to Training Videos List
            </Link>
            <br />
            {name && <h2>{name}</h2>}
            <VideoComponent src="http://dw0eyxo1j60a8.cloudfront.net" url={url} />
        </div>
    );
};

export default VideoDetails;
